module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-700.41d42457.woff2";